import { useState, useCallback } from 'react';

export function useFilterStorage<T>(key: string, defaultValue: T): [T, (value: T) => void] {
  const storageKey = `workflow-filters:${key}`;

  const [value, setValue] = useState<T>(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      return stored !== null ? JSON.parse(stored) : defaultValue;
    } catch {
      return defaultValue;
    }
  });

  const setStoredValue = useCallback((newValue: T) => {
    setValue(newValue);
    try {
      localStorage.setItem(storageKey, JSON.stringify(newValue));
    } catch {
      // localStorage full or unavailable
    }
  }, [storageKey]);

  return [value, setStoredValue];
}
